module.exports = __webpack_public_path__ + "img/AT0000100509734.5716a4b2.png";